import React from 'react'
import { AiFillFolder, AiOutlineDownload } from 'react-icons/ai';
import { ImBin } from 'react-icons/im';
import { auth, storage } from '../../../config/firebase.config';
import { getDownloadURL, ref } from 'firebase/storage';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

const FileCard = ({ isGridView, downloadFileName, handleDelete, index }) => {
    const currentUser = auth.currentUser;
    const handleDownload = async (selectedFileName) => {
        try {
            const storageRef = ref(storage, `${currentUser?.displayName}-${currentUser?.uid}/` + selectedFileName);
            const downloadURL = await getDownloadURL(storageRef);
            saveAs(downloadURL, selectedFileName);
        } catch (error) {
            toast.error(error.code);
        }
    }

    return (
        <div className={`shadow-md p-2 border-2 rounded-md w-100 capitalize cursor-pointer h-40 flex items-center ${isGridView ? 'flex-col justify-center' : 'flex-row justify-between'}`}>
            <div className='flex justify-center flex-col text-center'>
                <span className='text-xl md:text-3xl mx-auto'>
                    <AiFillFolder />
                </span>
                <h1 className='file-name'>{downloadFileName[index]?.slice(0, 25)}</h1>
            </div>
            <div className={`${isGridView ? 'w-full mt-5' : 'w-fit gap-2'} flex items-center justify-between`}>
                <button onClick={() => handleDelete(downloadFileName[index])} className='bg-red-500 text-white w-fit mx-auto p-2 text-2xl rounded-full'>
                    <ImBin />
                </button>
                <button onClick={() => handleDownload(downloadFileName[index])} className='bg-blue-500 text-white w-fit mx-auto p-2 text-2xl rounded-full'>
                    <AiOutlineDownload />
                </button>
            </div>
        </div>
    )
}

export default FileCard